import { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styles from './index.module.sass';
import branchBridge from 'bridge/branch-bridge';
import gaBridge from 'bridge/ga-bridge';
import { useAppContext } from 'use-app';
import ShareDialog from 'components/share-dialog';
import CoinGround from 'components/coin-ground';
import Envolope from 'components/envolope';
import Contents from 'components/contents';
import ErrorDialog from 'components/error-dialog';
import Header from 'components/header';
import LoadingDialog from 'components/loading-dialog';
import Button from 'components/button';
import Logo from 'components/logo';
import FormInput from 'components/form-input';
import Main from 'components/main';
import Title from 'components/title';
import Wrapper from 'components/wrapper';
import amplitude from 'service/amplitude';
import repo from 'service/repository';
import validation from 'service/validation';
import { PATH, VALIDATE_STATUS } from 'config';

const MOBILE = 'mobile';
const EMAIL = 'email';

const GetRewards = () => {
  const { setUserEmail, setUserMobile } = useAppContext();
  const location = useLocation();
  const history = useHistory();
  const { couponId } = useParams();

  //   verify page state
  const [init, setInit] = useState(false);
  const [passState, setPassState] = useState({});
  const [payload, setPayload] = useState({
    [MOBILE]: '',
    [EMAIL]: '',
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [errorCode, setErrorCode] = useState('');
  const [errorDialogShow, setErrorDialogShow] = useState(false);
  const [shareDialogShow, setShareDialogShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState({
    [MOBILE]: VALIDATE_STATUS.INIT,
    [EMAIL]: VALIDATE_STATUS.INIT,
  });
  const [SMSIsSended, setSMSIsSended] = useState(false);

  useEffect(() => {
    const { state } = location;
    if (location.state?.coupon) {
      document.title = location.state.coupon.attributes.campaign;
      gaBridge.logEvent('coupon_get_rewards', 'pageview', location.state.coupon.attributes.campaign);
      setPassState(state);
    } else {
      history.push(`${PATH.COUPON_OLD}/${couponId}`);
    }
  }, []); //eslint-disable-line

  const formData = [
    {
      id: MOBILE,
      type: 'tel',
      placeHolder: '註冊會員手機',
      maxLength: 10,

      onChange: value => {
        setPayload(prev => ({ ...prev, [MOBILE]: value }));
        if (value.length === 0) {
          setValid(prev => ({ ...prev, [MOBILE]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [MOBILE]: '必填' }));
        }
        let isPhoneNumber = validation.isPhoneNumber(value);
        if (isPhoneNumber) {
          setValid(prev => ({ ...prev, [MOBILE]: VALIDATE_STATUS.VALID }));
        } else {
          setValid(prev => ({ ...prev, [MOBILE]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [MOBILE]: '電話格式錯誤' }));
        }
      },
      onFocus: (coupon, source) => {
        amplitude.couponMobileOnClick(coupon, source);
      },
    },
    {
      id: EMAIL,
      type: 'email',
      placeHolder: '註冊會員 Email',

      onChange: value => {
        setPayload(prev => ({ ...prev, [EMAIL]: value }));
        if (value.length === 0) {
          setValid(prev => ({ ...prev, [EMAIL]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [EMAIL]: '必填' }));
          return;
        }
        let isEmail = validation.isEmail(value);
        if (isEmail) {
          setValid(prev => ({ ...prev, [EMAIL]: VALIDATE_STATUS.VALID }));
        } else {
          setValid(prev => ({ ...prev, [EMAIL]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [EMAIL]: '信箱格式錯誤' }));
        }
      },
      onFocus: (coupon, source) => {
        amplitude.couponEmailOnClick(coupon, source);
      },
    },
  ];

  const onRewards = () => {
    const { mobile, email } = payload;
    const { coupon, plateNumber, serialCode, source } = passState;
    setUserMobile(mobile);
    setUserEmail(email);
    setLoading(true);
    gaBridge.logEvent('coupon_get_rewards', 'click_next', coupon.attributes.campaign);
    repo
      .redeemCoupon(couponId, serialCode, plateNumber, email, mobile)
      .then(() => {
        setShareDialogShow(true);
        // sendSMS
        if (!SMSIsSended) {
          branchBridge.sendSMS(mobile);
          setSMSIsSended(true);
        }
        amplitude.completeOnClick('success', mobile, email, coupon, source);
      })
      .catch(error => {
        gaBridge.logEvent('coupon_get_rewards', 'error', coupon.attributes.campaign);
        const errorCode = error.response.data.error.code;
        setErrorDialogShow(true);
        setErrorCode(errorCode);
        amplitude.completeOnClick('failure', mobile, email, coupon, source, errorCode);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!passState.coupon) return <></>;

  const { coupon, source } = passState;

  return (
    <>
      <ShareDialog
        show={shareDialogShow}
        coupon={passState.coupon}
        source={passState.source}
        mobile={payload.mobile}
        email={payload.email}
        onClose={() => {
          setShareDialogShow(false);
        }}
      />
      <ErrorDialog
        show={errorDialogShow}
        mobile={payload.mobile}
        couponCode={passState.serialCode}
        plateNumber={passState.plateNumber}
        plateNumberAlreadyExistsErrorMessage={coupon.attributes.plate_number_already_exists_error_message}
        errorCode={errorCode}
        onClose={() => setErrorDialogShow(false)}
      />
      <LoadingDialog show={loading} />
      <CoinGround />
      <Wrapper show={init}>
        <Header>
          <Title>
            <img src={coupon.attributes.logo} alt="logo" />
          </Title>
        </Header>
        <div className={styles.congrates}>
          <div className={styles.left} />
          <div className={styles.right} />
        </div>
        <Main>
          <Envolope onLoad={() => setInit(true)} />
          <Contents>
            <div
              className={styles.subtext}
              dangerouslySetInnerHTML={{
                __html: coupon.attributes.congrates_text,
              }}
            />
            <div
              className={styles.gifts}
              dangerouslySetInnerHTML={{
                __html: coupon.attributes.promotion_content,
              }}
            />
            <div
              className={styles.subtext}
              dangerouslySetInnerHTML={{
                __html: coupon.attributes.insert_member_text,
              }}
            />
            <form className={styles.formReward}>
              {formData.map(data => {
                return (
                  <FormInput
                    type={data.type}
                    key={data.id}
                    value={payload[data.id]}
                    status={valid[data.id]}
                    errorMessage={errorMessage[data.id]}
                    id={data.id}
                    placeHolder={data.placeHolder}
                    maxLength={data.maxLength}
                    onChange={data.onChange}
                    onFocus={() => data.onFocus(coupon, source)}
                  />
                );
              })}
            </form>
            <Button disabled={!(valid[MOBILE] === 'valid' && valid[EMAIL] === 'valid')} onClick={onRewards}>
              {coupon.attributes.redeem_coupon_button}
            </Button>
          </Contents>
          <Logo icon={coupon.attributes.partner_icon} />
        </Main>
      </Wrapper>
    </>
  );
};

export default GetRewards;
